import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import axios from 'axios';
import { API_URL, SOCKET_URL } from '../../apiConfig';

const SettingsPage = ({ user, setUser, setAuthenticated }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: user?.name || '',
        email: user?.email || '',
    });
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setFormData({
            name: user?.name || '',
            email: user?.email || '',
        });
    }, [user]);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    const handleSaveProfile = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const firebaseUser = auth.currentUser;
            if (!firebaseUser) throw new Error("User not authenticated");
            const idToken = await firebaseUser.getIdToken();

            const response = await axios.put(
                `${API_URL}/users/profile`,
                { name: formData.name },
                { headers: { Authorization: `Bearer ${idToken}` } }
            );

            
            setUser(response.data);
            alert('Profile updated successfully!');

        } catch (err) {
            console.error("Error updating profile:", err);
            alert(err.response?.data?.error || "Failed to update profile.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <motion.div
            key="settings"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="max-w-2xl mx-auto p-4 md:p-8"
        >
            <div className="mb-8">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Settings</h1>
            </div>

            <div className="space-y-8">
                {/* Profile Settings */}
                <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-800 mb-4">Profile Information</h2>
                    <form onSubmit={handleSaveProfile} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1">Name</label>
                            <input
                                type="text"
                                value={formData.name}
                                onChange={(e) => setFormData({...formData, name: e.target.value})}
                                className="w-full px-4 py-2.5 rounded-lg bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-800"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1">Email</label>
                            <input
                                type="email"
                                value={formData.email}
                                disabled // Email is not editable for now
                                className="w-full px-4 py-2.5 rounded-lg bg-gray-200 border border-gray-300 cursor-not-allowed"
                            />
                        </div>
                        <div className="text-right">
                            <button 
                                type="submit" 
                                disabled={isSaving}
                                className="px-5 py-2 bg-black text-white rounded-lg font-semibold hover:bg-gray-800 transition-all text-sm disabled:bg-gray-400"
                            >
                                {isSaving ? 'Saving...' : 'Save Profile'}
                            </button>
                        </div>
                    </form>
                </div>

                {/* Account Actions */}
                <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                     <h2 className="text-xl font-bold text-gray-800 mb-2">Account Actions</h2>
                     <p className="text-gray-600 mb-4 text-sm">Need to sign out? You can do that here.</p>
                     <button 
                        onClick={handleLogout}
                        className="w-full md:w-auto px-5 py-2 border border-red-500 text-red-500 font-bold rounded-lg hover:bg-red-50 transition text-sm"
                    >
                        Log Out
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default SettingsPage;
